
const Filter=(data,filters)=>{
    console.log(data);
    let temp_filter=data;
    {filters && filters.map(f=>{
        if( f.value!=f.initial_value){
            temp_filter=temp_filter?.filter(d=>{
                return(
                    d[`${f.label}`]===f.value
                )
            })
        }
        }
        )}
   return temp_filter;
}
export default Filter;